import { render } from "./WordGame.vue?vue&type=template&id=8e7793da&scoped=true"
import script from "./WordGame.vue?vue&type=script&lang=js"
export * from "./WordGame.vue?vue&type=script&lang=js"

import "./WordGame.vue?vue&type=style&index=0&id=8e7793da&scoped=true&lang=css"

import exportComponent from "/Users/lhitchon/projects/yondercloud/wordgame/wordgame-cf/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7793da"]])

export default __exports__